module.exports = __webpack_public_path__ + "static/img/guide-07.098fb356.png";